/* global data, serverParams */
import Table from 'bam-node-savant-table/table'

import selected from './visual/selected'

const { is_team_type } = serverParams

function formatFactory(digits) {
    return function format(value) {
        try {
            return Number(value).toFixed(digits)
        } catch (e) {
            console.error(e)
            return '--'
        }
    }
}

const colspan = serverParams.splitYears ? 10 : 9
const secondaryHeaders = [
    {
        name: '',
        colspan,
        headerClass: 'th-name-header',
    },
    {
        name: 'Opportunities',
        colspan: 3,
        headerClass: 'th-title-header',
    },
    {
        name: 'Blocks Above Average',
        colspan: 3,
        headerClass: 'th-title-header',
    },
]

const headers = [
    {
        name: is_team_type ? 'Team' : 'Player',
        field: 'entity_name',
        customSortField: 'entity_name',
        headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
        fieldClass: `tr-data align-left table-static-column`,
        photo: is_team_type
            ? undefined
            : '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
        photoId: 'entity_id',
        defaultSortDir: 'asc',
        displayFn: (entity_name, d) =>
            is_team_type
                ? entity_name
                : `<a href="/savant-player/${d.entity_id}">${entity_name}</a>`, // what levels of unsafe is this?
    },
    {
        name: is_team_type ? '' : 'Team',
        field: is_team_type ? 'entity_name' : 'team_name',
        headerClass: `th-component-header`,
        fieldClass: `tr-data`,
        photo: '<img class="table-team-logo" src="{1}" onerror="this.onerror=\'\';this.src=\'/site-core/images/savant-mlb.svg\'" />',
        photoId: 'team_image_url',
        defaultSortDir: 'asc',
        photoOnly: true,
    },
    {
        name: 'Year',
        field: 'start_year',
        headerClass: `th-component-header align-center th-vertical-bottom ${
            serverParams.splitYears ? '' : ' hide'
        }`,
        fieldClass: `tr-data ${serverParams.splitYears ? '' : ' hide'}`,
    },
    {
        name: 'Block <br/> Opportunities',
        field: 'N',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => (value ? value.toLocaleString() : '--'),
    },
    {
        name: 'Catcher <br/> Blocking Runs',
        field: 'catcher_runs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        toolTip: 'Translation from blocks to a run value',
        displayFn: formatFactory(0),
    },
    {
        name: 'Blocks Above <br/>Average',
        field: 'diff_runner_pbwp',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        toolTip:
            'The number of PB&nbsp;+&nbsp;WP saved compared to the expectation of an average catcher',
        displayFn: formatFactory(0),
        highlightDynamic: true,
    },
    {
        name: 'Actual <br/> PB&nbsp;+&nbsp;WP',
        field: 'N_runner_pbwp',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        toolTip: 'Combined number of wild pitches and passed balls',
        type: 'number',
    },
    {
        name: 'Estimated  <br/>PB&nbsp;+&nbsp;WP',
        field: 'x_runner_pbwp',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        toolTip:
            'An estimate of the number of wild pitches and passed balls for a league average catcher.',
        displayFn: formatFactory(0),
    },
    {
        name: 'Blocks Above <br/>Average / Game',
        field: 'diff_rate_runner_pbwp',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        toolTip:
            'A rate stat based on an average catcher receiving 40 blocking chances per game.',
        displayFn: formatFactory(2),
    },
    //
    {
        name: 'Easy %',
        field: 'freq_pbwp_1_easy',
        headerClass:
            'th-component-header align-center th-vertical-middle border-left',
        fieldClass: 'tr-data border-left',
        type: 'number',
        toolTip: 'Percentage of pitches with a block probability of > 95%',
        displayFn: (val) => {
            if (val === null || val === undefined) return '--'

            try {
                return `${(val * 100).toFixed(1)}%`
            } catch (e) {
                console.error(e)
                return '--'
            }
        },
    },
    {
        name: 'Medium %',
        field: 'freq_pbwp_2_medium',
        headerClass: 'th-component-header align-center th-vertical-middle',
        fieldClass: 'tr-data',
        type: 'number',
        toolTip:
            'Percentage of pitches with a block probability between 85% and 95%',
        displayFn: (val) => {
            if (val === null || val === undefined) return '--'

            try {
                return `${(val * 100).toFixed(1)}%`
            } catch (e) {
                console.error(e)
                return '--'
            }
        },
    },
    {
        name: 'Tough %',
        field: 'freq_pbwp_3_tough',
        headerClass:
            'th-component-header align-center th-vertical-middle border-right',
        fieldClass: 'tr-data border-right',
        type: 'number',
        toolTip: 'Percentage of pitches with a block probability less than 85%',
        displayFn: (val) => {
            if (val === null || val === undefined) return '--'

            try {
                return `${(val * 100).toFixed(1)}%`
            } catch (e) {
                console.error(e)
                return '--'
            }
        },
    },
    {
        name: 'Easy',
        field: 'diff_runner_pbwp_1_easy',
        headerClass:
            'th-component-header align-center th-vertical-middle border-left',
        fieldClass: 'tr-data border-left',
        type: 'number',
        toolTip:
            'Block value of all pitches with a block probability greater than 95%',
        displayFn: (val) => {
            if (val === null || val === undefined) return '--'

            try {
                return `${Math.round(val)}`
            } catch (e) {
                console.error(e)
                return '--'
            }
        },
    },
    {
        name: 'Medium',
        field: 'diff_runner_pbwp_2_medium',
        headerClass: 'th-component-header align-center th-vertical-middle',
        fieldClass: 'tr-data',
        type: 'number',
        toolTip:
            'Block value of all pitches with a block probability between 85% and 95%',
        displayFn: (val) => {
            if (val === null || val === undefined) return '--'

            try {
                return `${Math.round(val)}`
            } catch (e) {
                console.error(e)
                return '--'
            }
        },
    },
    {
        name: 'Tough',
        field: 'diff_runner_pbwp_3_tough',
        headerClass:
            'th-component-header align-center th-vertical-middle border-right',
        fieldClass: 'tr-data border-right',
        type: 'number',
        toolTip:
            'Block value of all pitches with a block probability less than 85%',
        displayFn: (val) => {
            if (val === null || val === undefined) return '--'

            try {
                return `${Math.round(val)}`
            } catch (e) {
                console.error(e)
                return '--'
            }
        },
    },
    {
        name: '',
        field: 'entity_id',
        type: 'number',
        headerClass: `th-component-header${
            serverParams.entity_code === 'League' ? ' hide' : ''
        }`,
        fieldClass: `tr-data blocks-compare-btn${
            serverParams.entity_code === 'League' ? ' hide' : ''
        }`,
        displayFn: (id, d) => {
            const isVisualized = selected.includes(d)
            return `<button
                data-id="${id}"
                data-year="${d.start_year}"
                data-team="${d.key_team_id}"
                class="btn ${isVisualized ? '' : 'btn-default'} compare-btn"
                style="padding: 2px 8px"
            >
                ${isVisualized ? 'Go To Visual' : 'Load Visual'}
            </button>`
        },
    },
]

const tableDivId = 'catcher_blocking_table'
if (data && data.length) {
    loadTable(data)
}

// eslint-disable-next-line import/prefer-default-export
export function loadTable(data) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders,
        headers,
        highlightFalsy: true,
        data,
        uniqueId: 'catcher_id', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = populateUrl(column, state)
            window.history.replaceState('', '', url)
        },
    })
}

document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target[selectedIndex].text
    })
})

// document.getElementById('ddlType').addEventListener('change', (e) => {
//     window.location = populateUrl()
// })

document.querySelector('#ddlGroup').addEventListener('change', () => {
    window.location = populateUrl()
})

function populateUrl(sortColumn, sortDirection) {
    // duplicated logic in viz data fetching
    const parameters = {
        game_type: document.getElementById('ddlGameType').value,
        n: document.getElementById('ddlMinPitches')?.value || '',
        season_end: document.getElementById('ddlSeasonEnd')?.value || '',
        season_start: document.getElementById('ddlSeasonStart')?.value || '',
        split: document.getElementById('ddlSplitYears')?.value || '',
        team: document.getElementById('ddlTeam')?.value || '',
        type: document.getElementById('ddlGroup')?.value || '',
        with_team_only: document.getElementById('with-team-only')?.checked
            ? 1
            : 0,
    }

    if (parameters.type === 'Pitching Team') {
        parameters.team = ''
        parameters.n = ''
    }

    if (sortColumn) {
        parameters.sortColumn = sortColumn
        document.getElementById('sort').value = sortColumn
    } else {
        parameters.sortColumn = document.getElementById('sort').value
    }
    if (sortDirection) {
        parameters.sortDirection = sortDirection
        document.getElementById('sortDir').value = sortDirection
    } else {
        parameters.sortDirection = document.getElementById('sortDir').value
    }

    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})

let isFixedHeaderShowing = false

window.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
        checkHeaderPosition(tableDivId)
    })
})

function checkHeaderPosition(divId) {
    const $el = document.getElementById(divId)
    if (!$el) {
        return
    }
    const { top } = $el.getBoundingClientRect()
    const height = $el.querySelector(`table thead`).offsetHeight
    if (!isFixedHeaderShowing && top < 0) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && top - height > 0) {
        document
            .querySelector(`#${divId} table thead`)
            .classList.remove('fixed-header')
        isFixedHeaderShowing = false
    }
}

/* eslint-disable no-param-reassign */
function addStaticHeader(divId) {
    const $table = document.getElementById(divId)
    const width = $table.offsetWidth

    if (width && width > 767) {
        // Set TH Width before applying fixed-header
        $table
            .querySelector('.default-table-row')
            .querySelectorAll('td')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        $table
            .querySelector('.tr-component-row')
            .querySelectorAll('th')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        document
            .querySelector(`#${divId} table thead`)
            .classList.add('fixed-header')
    }
}
/* eslint-enable no-param-reassign */

function showWithTeam(value) {
    if (is_team_type) {
        return
    }

    const display = ['', 'split'].includes(value) ? 'none' : 'inline-flex'
    document.getElementById('with-team-only-wrapper').style.display = display
}
document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target.value === 'split'
                ? 'All - Split by Team'
                : e.target[selectedIndex].text

        if (type === 'Team') {
            showWithTeam(e.target.value)
        }
    })
})

showWithTeam(serverParams.team || '')
